import { render, staticRenderFns } from "./AccountingProduct.vue?vue&type=template&id=fd51323a&"
import script from "./AccountingProduct.vue?vue&type=script&lang=js&"
export * from "./AccountingProduct.vue?vue&type=script&lang=js&"
import style0 from "./AccountingProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports